import { Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-home-it',
  templateUrl: './it.component.html',
  styleUrl: './it.component.scss'
})
export class HomeItComponent {
  constructor(protected deviceService: DeviceDetectorService) { }

  get isMobile(){
    return this.deviceService.isMobile() ;
  }

  get isDesktop(){
    return this.deviceService.isDesktop() ;
  }
 }